// src/components/ChefOnboarding.js
import React, { useState } from "react";
import PhotoUploader from "./PhotoUploader";
import "./ChefOnboarding.css";

export default function ChefOnboarding() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    specialty: "",
    experience: "",
    photo_url: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePhotoUploaded = (deliveryURL, meta) => {
    console.log("Photo uploaded:", deliveryURL, meta);
    setFormData({ ...formData, photo_url: deliveryURL });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    
    try {
      const response = await fetch("/api/join", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          city: "toronto", // Default city for now
          specialties: [formData.specialty],
          bio: formData.experience,
          photo_url: formData.photo_url,
        }),
      });

      if (response.ok) {
        alert("Application submitted successfully!");
        // Reset form
        setFormData({
          name: "",
          email: "",
          specialty: "",
          experience: "",
          photo_url: "",
        });
      } else {
        const error = await response.json();
        alert(`Error: ${error.error || "Failed to submit application"}`);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit application. Please try again.");
    }
  };

  return (
    <div className="chef-onboarding">
      <h1>Chef Onboarding</h1>
      <form className="chef-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Your Name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="your.email@example.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="specialty">Culinary Specialty</label>
          <input
            type="text"
            id="specialty"
            name="specialty"
            placeholder="e.g., Italian Cuisine, Pastry, Seafood"
            value={formData.specialty}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="experience">Culinary Experience</label>
          <textarea
            id="experience"
            name="experience"
            placeholder="Tell us about your culinary experience, training, and what makes you unique as a chef..."
            value={formData.experience}
            onChange={handleChange}
            rows="4"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="photo">Chef Photo</label>
          <PhotoUploader
            onUploaded={handlePhotoUploaded}
            accept="image/*"
            maxMB={5}
            metadata={{
              type: 'chef',
              category: 'profile',
              source: 'onboarding-form'
            }}
          />
          {formData.photo_url && (
            <div className="photo-confirmation">
              ✅ Photo uploaded successfully
            </div>
          )}
        </div>

        <button type="submit" className="submit-btn">
          Submit Application
        </button>
      </form>
    </div>
  );
}
